"use strict";
export default {
  query(key) {
    if (window.location.href.indexOf("?") === -1) {
      return null;
    }
    const reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)", "i");
    const _query = window.location.href.substring(window.location.href.lastIndexOf("?") + 1).match(reg);
    if (_query != null) {
      return unescape(_query[2]);
    } else {
      return null;
    }
  },
  queryAll() {
    if (window.location.href.indexOf("?") === -1) {
      return null;
    }
    let search = window.location.href.substring(window.location.href.lastIndexOf("?") + 1);
    let _querys = new Object();
    var paramPart = search.split("&");
    for (var i = 0; i < paramPart.length; i++) {
      _querys[paramPart[i].split("=")[0]] = unescape(paramPart[i].split("=")[1]);
    }
    return _querys;
  },
  pushQuery(key, value) {
    let _href = window.location.href;
    if (this.queryAll() === null) {
      _href = `${_href}?${key}=${value}`;
    } else {
      if (this.query(key) === null) {
        _href = `${_href}&${key}=${value}`;
      } else {
        const reg = new RegExp(key + "=[^&]*", "i");
        _href = _href.replace(reg, `${key}=${value}`);
      }
    }
    window.history.pushState({}, "", _href);
  },
  pushQueryMap(map) {
    let _href = window.location.href;
    let _queryStr = "";
    if (this.queryAll() === null) {
      for (const key of map) {
        _queryStr = `${_queryStr}&${key[0]}=${key[1]}`;
      }
      _href = `${_href}?${_queryStr.substr(1)}`;
    } else {
      for (const key of map) {
        if (this.query(key[0]) === null) {
          _href = `${_href}&${key[0]}=${key[1]}`;
        } else {
          const reg = new RegExp(key[0] + "=[^&]*", "i");
          _href = _href.replace(reg, `${key[0]}=${key[1]}`);
        }
      }
    }
    window.history.pushState({}, "", _href);
  }
};
